import { Box } from "@mui/material";
import styled from "styled-components";

export const RateFormStyled = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  .rate {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .default-rate {
    display: flex;
    align-items: center;
    .MuiFormControlLabel-root {
      margin-right: 0 !important;
      padding: 0 0 0 8px !important;
    }
  }

  .flat-option {
    display: grid;
    justify-content: space-between;
    grid-template-columns: 165px 100px;
  }

  .role-option {
    display: flex;
    justify-content: space-between;
  }

  .services {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .roles {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .role {
    display: grid;
    justify-content: space-between;
    align-items: center;
    grid-template-columns: 1fr 100px;
  }
`;
